function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  className: "goals_svg__cls-1",
  d: "M12.5 25A12.5 12.5 0 1125 12.5 12.51 12.51 0 0112.5 25zm0-23.5a11 11 0 1011 11 11 11 0 00-11-11z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "goals_svg__cls-1",
  d: "M12.5 20a7.5 7.5 0 117.5-7.5 7.51 7.51 0 01-7.5 7.5zm0-14a6.5 6.5 0 106.5 6.5A6.51 6.51 0 0012.5 6z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "goals_svg__cls-1",
  cx: 12.5,
  cy: 12.5,
  r: 2.5
});
function SvgGoals(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default ForwardRef;